import Vue from 'vue'
import axios from 'axios'

// axios.defaults.baseURL = 'http://127.0.0.1:3333/' 
// axios.defaults.headers.common['Authorization'] = 'abc123'
// axios.defaults.headers.get['Accepts'] = 'application/json'

let urlBase = ''

if (process.env.NODE_ENV === 'development') {
    urlBase = 'http://127.0.0.1:3333/'
} else if (process.env.NODE_ENV === 'production') {
    // urlBase = 'https://api.siriema.codelevel.com.br/'
    // urlBase = 'https://app.siriema.codelevel.com.br/'
    urlBase = 'https://mrb-adapt-api.codelevel.com.br'
}

Vue.use({
    install(Vue) {
        Vue.prototype.$http = axios.create({
            baseURL: `${urlBase}`,
            headers: {
                "Access-Control-Allow-Origin": "*"
            }
            // headers: {
            //     "Authorization": `Bearer ${localStorage.getItem('token')}`
            // }
            // headers:{
            //     "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjEsImRhdGEiOnsidXNlcm5hbWUiOiJVc2VyIERlZmF1bHQiLCJlbWFpbCI6ImFwaUBhcGkuY29tIiwiYWNjZXNzIjoibWFuYWdlciJ9LCJpYXQiOjE1ODA3NDg0MDcsImV4cCI6MTU4MDgzNDgwN30.u8XjVwyKcMu5TTqWsKmnKY19YNBiYq1P_GIOpwKisDw"
            // }
        })
    }
})